import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalLogProduto",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><svg width=\"22\" height=\"22\" viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4339_1347)\"><path opacity=\"0.4\" d=\"M24.3113 6.93848L22.0604 9.18945C21.8309 9.41895 21.4598 9.41895 21.2303 9.18945L15.8104 3.76953C15.5809 3.54004 15.5809 3.16895 15.8104 2.93945L18.0613 0.688477C18.9744 -0.224609 20.4588 -0.224609 21.3768 0.688477L24.3113 3.62305C25.2293 4.53613 25.2293 6.02051 24.3113 6.93848ZM13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575992 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79084 16.3281 5.79084 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\"></path><path d=\"M13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575991 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79083 16.3281 5.79083 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\"></path></g><defs><clipPath id=\"clip0_4339_1347\"><rect width=\"25\" height=\"25\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_8 = { class: "m-0 subtitulo cor_texto_1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  class: "modal-body d-flex flex-column p-5 gap-5",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_12 = { class: "d-block" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_8, "N° " + _toDisplayString(_ctx.log.id) + " log", 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fechaModal())),
              "aria-label": "Close"
            }, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("code", _hoisted_12, _toDisplayString(_ctx.log?.mensagem_retorno), 1)
          ]),
          _hoisted_13
        ])
      ])
    ])
  ]))
}